import { translate } from "../util/intlHelper";

const translationMiddleware = (store) => (next) => (action) => {
  // Only act on string payloads that start with "translate:"
  if (
    action &&
    typeof action.payload === "string" &&
    action.payload.startsWith("translate:")
  ) {
    try {
      const translationKey = action.payload.replace("translate:", "");

      const translatedMessage = translate(translationKey, translationKey);

      // Ensure translated result is a valid string (not undefined or object)
      if (!translatedMessage || typeof translatedMessage !== "string") {
        console.warn("Invalid translation result:", translatedMessage);
        return next(action); // fallback to original
      }

      return next({ ...action, payload: translatedMessage });
    } catch (error) {
      console.error("Translation error:", error);
      return next(action); // fallback to original
    }
  }

// Warn if payload is undefined (optional)  
  if (action.payload === undefined) {
    console.warn("Undefined payload detected in action:", action);
  }
  console.log("Translation middleware passed action:", action);
  return next(action); // pass action unchanged
};

export default translationMiddleware;
